module.exports = __webpack_public_path__ + "assets/img/C-a4da28d5.jpg";